export default __webpack_public_path__ + "static/media/puc.e2f86055.png";